import { styled } from '@mui/material/styles';

const IconWrap = styled('span')({
  display: 'inline-flex',
});

export function ProfileIcon() {
  return (
    <IconWrap>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M4.5 20.25C5.93552 17.5675 8.72092 15.75 12 15.75C15.2791 15.75 18.0645 17.5675 19.5 20.25"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </IconWrap>
  );
}
